export default __webpack_public_path__ + "static/media/ipo.b91d7a9d.png";